import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { MAHEntity } from "../../../Data/MedicinalProductData/MAHEntity";
import { BaseNode } from "../../BaseNode";
import { TreeNodeOrganisationList } from "../../Art57Node/ListEntity/TreeNodeOrganisationList";
import { environment } from "../../../../../../environments/environment";


export class MAHAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        const createChildTemplateparams = {nodeType:2};
        model.localnumber = model.ev_Code;
        super(injector, labelTemplate, MAHEntity, useHist ? AutoUploadEntityEnum.mahHist : AutoUploadEntityEnum.mah, ServiceEnum.MedicinalProducts, parent, model,TreeNodeOrganisationList,false, disableAutoUpload,cloningNode, createChildTemplateparams);
        this.labelNodeName = 'MAH';
        this.useHist = useHist;
      }


    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: MAHAutoUploadEntity = new MAHAutoUploadEntity(this.ioc!, this.label!, newParent, this.data.model,false, this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      clonedNode.cloningNode = false;
      return clonedNode;

    }

}